{
  "footer": {
    "navigation": "Sidfot",
    "socialMedia": "Sociala medier",
    "newTab": "(öppnas i ny flik)",
    "pdfDocument": "(PDF)",
    "social": {
      "facebook": "GlobalConnect på Facebook",
      "youtube": "GlobalConnect på YouTube",
      "linkedin": "GlobalConnect på LinkedIn",
      "instagram": "GlobalConnect på Instagram"
    },
    "se": {
      "menus": {
        "globalConnect": "GlobalConnect",
        "purchaseInformation": "Köpinformation",
        "customerService": "Kundservice"
      },
      "links": {
        "aboutUs": "Om GlobalConnect",
        "euProjects": "EU-finansierade projekt",
        "privacyPolicy": "Integritetspolicy",
        "cookiePolicy": "Cookiepolicy",
        "career": "Karriär",
        "press": "Press",
        "terms": "Allmänna villkor",
        "fiberInterest": "Fiber intresseanmälan",
        "leisureHomeServices": "Fritidshus tjänster",
        "faq": "Frågor och svar",
        "contact": "Kontakta oss",
        "serviceStatus": "Driftinformation",
        "landowners": "Markägare",
        "accessibility": "Tillgänglighet"
      }
    },
    "fi": {
      "menus": {
        "globalConnect": "GlobalConnect",
        "support": "Support",
        "termsAndPricing": "Villkor och prislista"
      },
      "links": {
        "aboutUs": "Om oss",
        "career": "Karriär",
        "news": "Nyheter",
        "media": "För media",
        "sustainability": "Hållbarhet",
        "businessCustomers": "Företagskunder",
        "customerService": "Kundservice",
        "faq": "Vanliga frågor",
        "cancellationForm": "Ångerblankett",
        "serviceStatus": "Driftstörningar",
        "cableInformation": "Kabelinformation",
        "accessibility": "Tillgänglighet",
        "priceList": "Prislista",
        "salesTerms": "Försäljningsvillkor",
        "serviceTerms": "Servicevillkor",
        "privacyPolicy": "Integritetspolicy",
        "cookiePolicy": "Cookiepolicy"
      }
    }
  },
  "errorComponent": {
    "404": "Vi letade länge och väl, men sidan du söker verkar inte finnas",
    "409": "Denna adress är redan kopplad och klar!",
    "500": "Oj, det verkar som att något gick fel tyvärr!",
    "503": "Oj, något gick fel hos oss!",
    "statusFallback": "Oj, något gick fel.",
    "buttonTextPublicUrl": "Klicka här för att komma tillbaka till vår startsida",
    "buttonTextPortalUrl": "Klicka här för att gå tillbaka"
  },
  "addressComponent": {
    "yourAddress": "Din adress",
    "searchNewAddress": "Sök ny adress"
  },
  "addressInfoTranslations": {
    "street": {
      "label": "Gatuadress",
      "placeholder": "Gatuadress"
    },
    "postalCode": {
      "label": "Postnummer",
      "placeholder": "Postnummer",
      "error": {
        "pattern": "Postnumret måste vara 5 siffror långt"
      }
    },
    "city": {
      "label": "Ort",
      "placeholder": "Ort"
    },
    "country": "Land",
    "countryCode": {
      "error": {
        "pattern": "Felaktig landskod"
      }
    },
    "countries": {
      "sweden": "Sverige",
      "norway": "Norge",
      "aland": "Åland"
    },
    "requiredError": "Detta fält är obligatoriskt",
    "sameBillingAddress": "Fakturaadressen är samma som leveransadressen"
  },
  "commonInfoTranslations": {
    "phoneNumber": {
      "label": "Telefonnummer",
      "countryCodeTitle": "Landskod",
      "placeholder": {
        "+46": "9 siffror, exempel: 701234567",
        "+47": "8 eller 12 siffror långt",
        "+358": "5 till 10 siffror långt",
        "+999": "+xx xxxxxx"
      },
      "error": {
        "pattern": "Endast siffror tillåtna",
        "lengthNine": "Telefonnumret måste vara 9 siffror långt",
        "lengthEightOrTwelve": "Telefonnumret måste vara 8 eller 12 siffror långt",
        "lengthFiveToTen": "Telefonnumret måste innehålla mellan 5 och 10 siffror",
        "otherCountryCode": "Telefonnumret ska börja med '+' följt av siffror."
      }
    },
    "email": {
      "label": "E-postadress",
      "placeholder": "example@email.com",
      "error": {
        "notMatching": "E-postadresserna måste vara lika.",
        "pattern": "E-postadressen måste matcha formatet example@email.com"
      }
    },
    "confirmEmail": "Repetera e-postadress",
    "requiredError": "Detta fält är obligatoriskt."
  },
  "earliestActivationDateTranslations": {
    "earliestActivationDate": "Tidigaste startdatum",
    "toolTipInfo": "Tidigaste startdatum avgörs baserat på om adressen har aktiva tjänster idag. Det kan vara en bindningstid som blockerar önskat startdatum. För att kontrollera möjligheterna att tidigarelägga startdatumet kontakta vald leverantör efter slutförd beställning."
  }
}
